import { Card, CellTextSub, Heading, Text } from '@backend/lib-design-system';
import { styled } from 'styled-components';

import { getMediaQuery } from '~/utils/responsive/media';

export const TitleWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 8px;
`;

export const GreyDot = styled.span`
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.info?.normal};
`;

export const HeaderRow = styled.div`
  gap: 16px;
  display: flex;
  justify-content: center;

  ${getMediaQuery('mobile')} {
    flex-direction: column;
    justify-content: stretch;
  }
`;

export const HeaderCard = styled(Card)`
  max-width: 100%;
  background: white;
  box-shadow: 0 1px 6px 0 rgba(147, 163, 192, 0.5);

  ${getMediaQuery('tablet', 'laptop', 'desktop')} {
    min-width: 166px;
  }
`;

export const HeaderCardContainer = styled.div`
  display: flex;
  gap: 24px;
  align-items: center;
`;

export const HeaderCardText = styled(CellTextSub)`
  overflow: hidden;
`;

export const MissionHeaderTitle = styled(Heading)`
  max-width: 720px;
  margin: 0 auto !important;
`;

export const MissionHeaderSubtitle = styled(Text)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: ${({ theme }) => theme.colors.info?.normal};
`;
